module.exports = __webpack_public_path__ + "98b15be78c29e50ed83df610d1c44f79.gif";